import { useEffect, useState, useCallback } from "react";

/** Fired when sessionStorage.featuresList is updated (e.g. after useDynamicMenu loads). */
export const FEATURES_LIST_UPDATED_EVENT = "features-list-updated";

function getFeatureName(item) {
  return item?.feature_name ?? item?.featureName ?? item?.FEATURE_NAME ?? "";
}

/** True only when the role row grants access (view + active). */
function isFeatureEnabledForRole(feature) {
  if (!feature) return false;
  const canView =
    feature.can_view === true ||
    feature.can_view === 1 ||
    feature.can_view === "1" ||
    feature.can_view === "true" ||
    feature.canView === true;
  const active =
    feature.is_active !== false &&
    feature.isActive !== false &&
    feature.is_active !== 0;
  return Boolean(canView && active);
}

/**
 * Returns whether the named master feature is enabled for the current role
 * (reads sessionStorage.featuresList from userrolefeaturepermission).
 */
function useFeaturePermission(featureName) {
  const [enabled, setEnabled] = useState(false);

  const recompute = useCallback(() => {
    const featureList = JSON.parse(
      sessionStorage.getItem("featuresList") || "[]"
    );
    const feature = featureList.find(
      (item) => getFeatureName(item) === featureName
    );
    setEnabled(isFeatureEnabledForRole(feature));
  }, [featureName]);

  useEffect(() => {
    recompute();
    const onListUpdated = () => recompute();
    window.addEventListener(FEATURES_LIST_UPDATED_EVENT, onListUpdated);
    const onVisible = () => {
      if (document.visibilityState === "visible") recompute();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener(FEATURES_LIST_UPDATED_EVENT, onListUpdated);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [recompute]);

  return enabled;
}

export default useFeaturePermission;
